import { StrictLocalMsg } from "@faire/localization/react/StrictLocalMsg";
import { isChildOfType } from "@faire/slate/lib/slotUtils";

import type { IText } from "./types";

export const assertText = (text: IText | undefined, message: string): void => {
  if (
    text &&
    typeof text !== "string" &&
    !isChildOfType(text, StrictLocalMsg)
  ) {
    // oxlint-disable-next-line no-console
    console.error(message);
  }
};

export const hasText = (value?: IText): boolean => {
  if (value == null) {
    return false;
  }
  if (typeof value === "string") {
    return value !== "";
  }
  return true;
};
